// How tall a forecast report may be in the chat console before it is cut off.
//
// A report is long — assessment, drivers, considerations — and posting it whole pushed the
// rest of the conversation off screen, so the message you just asked for buried the ones
// before it. Capped at a FRACTION of the console rather than a line count: the console is
// user-resizable and theme font sizes differ, so a fixed line count reads as two thirds on
// one setup and everything on another.
export const REPORT_MAX_FRACTION = 2 / 3;

/**
 * Pixel cap for a report body, given the console's own height.
 *
 * Returns null when the height is not measurable yet (first paint, a detached node): the
 * caller then renders UNCLAMPED, because clamping to a guessed height would cut the text
 * at an arbitrary place and, on a tall console, hide text that had room to show.
 *
 * @param {number|null|undefined} consoleHeightPx
 * @returns {number|null}
 */
export function reportClampHeight(consoleHeightPx) {
  if (typeof consoleHeightPx !== "number") return null;
  if (!Number.isFinite(consoleHeightPx) || consoleHeightPx <= 0) return null;
  return Math.floor(consoleHeightPx * REPORT_MAX_FRACTION);
}

/**
 * Whether content of `contentHeightPx` is actually cut off by `capPx`.
 *
 * The 1px tolerance is not cosmetic: sub-pixel layout routinely makes scrollHeight exceed
 * clientHeight by a fraction on content that is fully visible, and without it every report
 * would claim to be truncated and show a "…" that leads nowhere.
 */
export function isReportTruncated(contentHeightPx, capPx) {
  if (typeof capPx !== "number" || typeof contentHeightPx !== "number") return false;
  return contentHeightPx - capPx > 1;
}
